import React from 'react';
import AppDemo from './AppDemo';
import StoreLinks from './StoreLinks';

export default function LandingHero({ onLogin }) {
return (
    <header id="top" className="dl-hero">
      <div className="dl-hero-grid" aria-hidden="true" />
      <div className="dl-orbit dl-orbit-one" aria-hidden="true" />
      <div className="dl-orbit dl-orbit-two" aria-hidden="true" />
      <svg className="dl-route-line" viewBox="0 0 900 900" aria-hidden="true">
        <path d="M-20 735 C170 670 150 500 340 465 S475 220 700 280 S810 130 930 70" />
      </svg>
      <div className="dl-hero-inner">
        <div className="dl-hero-copy">
          <div className="dl-eyebrow dl-reveal"><span /> POLSKI EKOSYSTEM KIEROWCÓW</div>
          <h1 className="dl-hero-title">
            <span className="dl-title-mask"><b>Twoje miasto.</b></span>
            <span className="dl-title-mask"><b>Twoja <em>arena.</em></b></span>
          </h1>
          <p className="dl-hero-lead dl-reveal">Jedna aplikacja dla ludzi, których łączy droga. Odkrywaj, rywalizuj, buduj garaż i zobacz motoryzację swojego miasta na żywo.</p>
          <div className="dl-hero-actions dl-reveal">
            <a className="dl-button dl-button-primary dl-magnetic" href="#join"><span>Dołącz do VROOM</span><i>↗</i></a>
            <button className="dl-button dl-button-ghost" type="button" onClick={onLogin}>Mam już konto</button>
          </div>
          <StoreLinks />
        </div>
        <div className="dl-hero-stage"><AppDemo compact /></div>
      </div>
      <a className="dl-scroll-cue" href="#experience"><span>SCROLL TO DRIVE</span><i /></a>
    </header>
  );
}


